import React, { useContext } from "react";
import { ContextStore } from "../../App";

const InputsData = () => {
  const { enquiryFormData, setEnquiryFormData } = useContext(ContextStore);
  const { name, email, phone, pincode } = enquiryFormData;
  const enquiryInputs = [
    {
      id: 1,
      name: "name",
      label: "Your Name",
      placeholder: "Enter your name",
      type: "text",
      value: name,
    },
    {
      id: 2,
      name: "email",
      label: "Your Email",
      placeholder: "Enter your email",
      type: "email",
      value: email,
    },
    {
      id: 3,
      name: "phone",
      label: "Your Mobile Number",
      placeholder: "Enter your number",
      type: "tel",
      value: phone,
    },
    {
      id: 4,
      name: "pincode",
      label: "Your Pincode",
      placeholder: "Enter your pincode",
      type: "number",
      value: pincode,
    },
  ];

  return {
    enquiryInputs,
  };
};

export default InputsData;
